import(/* webpackMode: "eager" */ "/tmp/build/80754af9/repo/apps/quales-web/app/(auth)/error.tsx");
